import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import AnimationPage from '../../pages/AnimationPage';
import CustomCheckbox from '../CustomCheckbox';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useToast } from 'use-toast-mui';
import { responsibilities, classifications, Respo } from '../../constants/constants';
import { RHFCheckbox } from '../CheckBox';
import { useForm } from 'react-hook-form';
import { FormInputText } from '../../form-components/FormInputText';
import { getAllSalary } from '../../api/salary-managemet';
import QueryString from 'qs';
import { errorMessages, formatterCurrency } from '../../utils/methods';
import useUserAuth from '../../utils/useUserAuth';

const initialQuery = {
  page: 1,
  limit: 10,
  headBranchId: null,
  branchId: null,
  searchInput: '',
  responsibilities: [],
  classifications: [],
};

var qs = require('qs');

const PayManagement = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const user = useSelector(state => state.user.user);
  const canSalaryViewEdit = useUserAuth('EMPLOYEE_SALARY_VIEW_EDIT');
  const token = useSelector(function (state) {
    return state.user.user.token;
  });
  const userBranch = useSelector(function (state) {
    return state.user.user.branch;
  });
  const userHead = useSelector(function (state) {
    return state.user.user.headBranch;
  });
  const initialQuery = {
    page: 1,
    limit: 10,
    headBranchId: userHead?.headBranchId,
    branchId: userBranch?.branchId,
    searchInput: '',
    responsibilities: [],
    classifications: [],
  };
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const { handleSubmit, control, reset, setValue } = useForm({
    defaultValues: initialQuery,
  });
  const [employees, setEmployees] = useState();
  const [query, setQuery] = useState(initialQuery);

  const handleChangePage = (_, value) => {
    setQuery({ ...query, page: value });
  };

  // const onCheckboxChange = (name, e) => {
  //   let value = '';

  //   if (Array.isArray(e)) {
  //     value = e;
  //   } else value = e.target.checked;

  //   setValue(name, value);

  //   // setQuery({ ...query, [name]: value });

  //   if (value === true) {
  //     const updatedQuery = {
  //       ...query,
  //       responsibilities: [...query.responsibilities, name],
  //     };
  //     setQuery(updatedQuery);
  //   } else {
  //     const updatedResponsibilities = query.responsibilities.filter(responsibility => responsibility !== name);
  //     setQuery({
  //       ...query,
  //       responsibilities: updatedResponsibilities,
  //       [name]: value,
  //     });
  //   }
  // };

  const staffList = async () => {
    const queryString = qs.stringify(query);
    if (!user.headBranch?.headBranchId || (user.centerType === 'BRANCH' && !user.branch?.branchId)) {
      toast.warning(t('Please select a point'));
      setEmployeeList([]);
    } else {
      try {
        setLoading(true);
        await getAllSalary(queryString, token).then(result => {
          setLoading(false);
          setEmployeeList(result);
        });
      } catch (error) {
        toast.error(errorMessages(error));
      }
    }
  };

  const submit = async values => {
    setQuery({ ...query, ...values, headBranchId: userHead?.headBranchId, branchId: userBranch?.branchId });
  };

  useEffect(() => {
    // if (userBranch?.branchId) {
    setQuery(prevQuery => ({
      ...prevQuery,
      headBranchId: userHead?.headBranchId,
      branchId: userBranch?.branchId,
    }));
    // }
  }, [userBranch, userHead]);

  useEffect(() => {
    staffList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const setInitial = () => {
    // Reset the query state to its initial values
    setQuery(prevQuery => ({
      ...prevQuery,
      page: 1,
      limit: 10,
      searchInput: '', // Clear the searchInput from the query state
      responsibilities: [],
      classifications: [],
    }));

    // Reset the form field values
    reset({
      searchInput: '', // Clear the search input value in the form
      responsibilities: [],
      classifications: [],
    });

    // Optional: You can explicitly set the 'searchInput' to an empty string
    setValue('searchInput', '');
  };

  return (
    <AnimationPage>
      <div>

        <Box
          component={Paper}
          elavation={2}
          sx={{
            background: '#fff',
            borderRadius: '10px',
            padding: '40px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '28px' }}>
              {t('Search Employee')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '370px' }}
              size="small"
              control={control}
              placeholder={t('Type the employee name')}
              // id="outlined-search"
              name="searchInput"
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  handleSubmit(submit)();
                }
              }}
            />
            <Button
              color="info"
              sx={{
                background: '#0F7F85',
                color: '#fff',
                ml: '4px',
                width: '62px',
                height: '40px',
                border: '1px solid #0F7F85',
                '&:hover': {
                  background: 'none',
                  color: '#0F7F85',
                },
              }}
              variant="text">
              {t('Search')}
            </Button>
          </Box>

          <Box sx={{ mt: '16px', display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ width: '8%' }} className="title">
              {t('Responsibilities')}
            </Typography>
            <RHFCheckbox control={control} row name="responsibilities" spacing={2} options={Respo} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mt: '13px',
              mb: '17px',
            }}>
            <Typography sx={{ width: '8%' }} className="title">
              {t('Employment Status')}
            </Typography>
            <RHFCheckbox control={control} row name="classifications" spacing={2} options={classifications} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              justifyContent: 'center',
              mb: '24px',
            }}>
            <Button
              variant="contained"
              onClick={handleSubmit(submit)}
              sx={{
                background: '#0F7F85',
                borderRadius: '5px',
                height: '40px',
                '&:hover': {
                  background: '#0F7F85',
                  color: '#fff',
                  cursor: 'default',
                },
              }}>
              {t('Apply and Search')}
            </Button>
            <Button
              onClick={setInitial}
              variant="text"
              sx={{
                background: '#e0e0e0',
                border: '1px solid #e0e0e0',
                height: '40px',
                color: '#000',
                borderRadius: '5px',
                '&:hover': {
                  cursor: 'default',
                  background: 'none',
                  color: '#000',
                },
              }}>
              {t('Clear Filters')}
            </Button>
          </Box>
          <hr
            style={{
              border: '1px solid #e1e1e1',
              margin: '0px !important',
              padding: '0px',
            }}
          />
          <Box sx={{ mt: '30px' }}>
            <TableContainer sx={{ border: '1px solid #ddd', borderRadius: '5px' }}>
              <Table sx={{ minWidth: 550 }} size="small" aria-label="a dense table">
                <TableHead sx={{ background: '#fafbfc' }}>
                  <TableRow sx={{ height: '40px' }}>
                    <TableCell
                      align="center"
                      sx={{
                        borderRight: '1px solid #ddd',
                        fontWeight: 500,
                        fontSize: '12px',
                      }}>
                      {t('Name')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderRight: '1px solid #ddd',
                        fontWeight: 500,
                        fontSize: '12px',
                      }}>
                      {t('Hiring Date')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderRight: '1px solid #ddd',
                        fontWeight: 500,
                        fontSize: '12px',
                      }}>
                      {t('Basic Pay')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderRight: '1px solid #ddd',
                        fontWeight: 500,
                        fontSize: '12px',
                      }}>
                      {t('1-on-1 Pay')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderRight: '1px solid #ddd',
                        fontWeight: 500,
                        fontSize: '12px',
                      }}>
                      {t('Group Pay')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderRight: '1px solid #ddd',
                        fontWeight: 500,
                        fontSize: '12px',
                        borderBottom: '1px solid #ddd',
                      }}>
                      {t('Commission')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: 500,
                        fontSize: '12px',
                        borderBottom: '1px solid #ddd',
                      }}>
                      {t('Effective from')}
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {employeeList?.content?.map((row, index) => (
                    <TableRow
                      {...(canSalaryViewEdit ? { component: Link, to: `/salary/${row.id}` } : {})}
                      sx={{
                        height: '40px',
                        textDecoration: 'none',
                        '&:last-child td, &:last-child th': { borderBottom: 0 },
                        cursor: canSalaryViewEdit ? 'pointer' : 'default',
                      }}>
                      <TableCell sx={{ borderRight: '1px solid #ddd' }} align="center" component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ddd' }} align="center">
                        {row.hiredDate}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ddd' }} align="center">
                        {formatterCurrency(row.baseSalary)}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ddd' }} align="center">
                        {formatterCurrency(row.privateLessonAllowance)}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ddd' }} align="center">
                        {formatterCurrency(row.groupLessonAllowance)}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ddd' }} align="center">
                        {row.commission ?? '-'}
                      </TableCell>
                      <TableCell align="center">{row.startDate ?? '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack spacing={1} sx={{ mt: '20px', ml: '40%' }}>
              <Pagination
                count={Math.ceil(employeeList.totalElements / query.limit) || 0}
                onChange={handleChangePage}
                page={query.page}
                color="primary"
                variant="outlined"
                shape="rounded"
                sx={{
                  '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium': {
                    background: '#0F7F85',
                    border: 'none',
                    height: '24px',
                    minWidth: '24px',
                  },
                  '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium.Mui-selected': {
                    background: '#0F7F85',
                    color: '#fff',
                  },
                  '.MuiPaginationItem-icon': {
                    color: '#fff',
                  },
                }}
              />
            </Stack>
          </Box>
        </Box>
      </div>
    </AnimationPage>
  );
};

export default PayManagement;
